import Immutable from 'immutable';

export var CategoryType = Immutable.Record({
    intId: undefined,
    id: undefined,
    name: undefined,
    title: undefined,
    cargos: [],
    parameters: []
});

export var CargoType = Immutable.Record({
    system_id: undefined,
    id: undefined,
    name: undefined,
    sort: undefined,
    parent_id: undefined,
    predefined: undefined,
    stuff_type_id: undefined,
    attributes: Immutable.Map(),
    is_true_cargo: undefined,
    show_approximate_units_warning: false,
});

export var AttributeType = Immutable.Record({
    id: undefined,
    name: undefined,
    title: undefined,
    type: undefined,
    value: undefined,
    values: undefined,
    error: undefined
});

export var ParameterType = Immutable.Record({
    id: undefined,
    name: undefined,
    title: undefined,
    type: undefined,
    value: undefined,
    values: undefined,
    tip: undefined,
    price: undefined,
    price_coef: undefined,
    error: undefined
});



// WEBPACK FOOTER //
// ./client/types/index.js